import { render, staticRenderFns } from "./ClientViewDravler.vue?vue&type=template&id=ae898a66&scoped=true"
import script from "./ClientViewDravler.vue?vue&type=script&lang=js"
export * from "./ClientViewDravler.vue?vue&type=script&lang=js"
import style0 from "./ClientViewDravler.vue?vue&type=style&index=0&id=ae898a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae898a66",
  null
  
)

export default component.exports